module.exports = __webpack_public_path__ + "static/media/api.3fa21b04.svg";